import Vue from 'vue'
import Index from './Index.vue'
Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../../../../theme/index.css';
import 'element-ui/lib/theme-chalk/display.css';
Vue.use(ElementUI);

new Vue({
    render: h => h(Index),
}).$mount('#index')